import React from 'react';
export function Footer() {
  return <footer className="border-t border-led/10 bg-ink px-5 py-8 text-center sm:px-8" data-id="element-85" data-mp="32wd2qgad7ltj">
      <p className="text-[10px] uppercase tracking-[0.22em] text-led/45" data-id="element-86" data-mp="3gg0zo4mhnzy6">© Improbable Arts</p>
    </footer>;
}